import React, { ReactElement, memo, useMemo } from "react";

// components
import { ExtraItemInlineWidget, OfferBundleHalfCard } from "@swiggy-private/cart-ui";

// types
import { ExtraItem } from "@swiggy-private/cart-types";
import { ReviewedCart } from "@cart-client/interfaces/Cart";

// hooks
import { useOfferBundle } from "@cart-client/hooks/useOfferBundle";
import { useOfferBundleAnalytics } from "@cart-client/hooks/useOfferBundleAnalytics";

import {
    getExtraItems,
    getHalfCardItemAndPlanDetails,
    shouldShowHalfCardOnMount,
} from "@cart-client/helpers/OfferBundle";

// constants

export interface IExtraItemListProps {
    cartResponse: ReviewedCart;
}

const ExtraItemList = ({ cartResponse }: IExtraItemListProps): ReactElement => {
    const { items, showHalfCard } = useMemo(
        () => ({
            items: getExtraItems(cartResponse),
            showHalfCard: shouldShowHalfCardOnMount(cartResponse),
        }),
        [cartResponse],
    );

    const offerBundle = useOfferBundle({
        showHalfCard,
    });

    const { impressionHalfCard, clickHalfCardConfirm, impressionCartInline, clickCartInline } =
        useOfferBundleAnalytics();

    const { halfCardItem, planDetails, isM2CFlow } = useMemo(
        () => getHalfCardItemAndPlanDetails(offerBundle.showHalfCard),

        [offerBundle.showHalfCard],
    );

    return (
        <>
            {items.map((item: ExtraItem, index: number) => {
                return (
                    <ExtraItemInlineWidget
                        key={index}
                        item={item}
                        analyticsEvents={{
                            impressionCartInline,
                            clickCartInline,
                        }}
                        {...offerBundle}
                    />
                );
            })}
            {offerBundle.showHalfCard ? (
                <OfferBundleHalfCard
                    isM2CFlow={isM2CFlow}
                    item={halfCardItem}
                    planDetails={planDetails}
                    onClose={offerBundle.onHalfCardClose}
                    onHalfCardConfirm={offerBundle.onHalfCardConfirm}
                    analyticsEvents={{
                        impressionHalfCard,
                        clickHalfCardConfirm,
                    }}
                />
            ) : null}
        </>
    );
};

export default memo(ExtraItemList);
